import React from 'react';
import './StatusBadge.scss';

type Status = 'in-progress' | 'completed';

interface StatusBadgeProps {
  startDate?: string;
  endDate?: string;
  isActive?: boolean;
  className?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  startDate,
  endDate,
  isActive,
  className,
}) => {
  let status: Status = 'in-progress';

  if (isActive !== undefined) {
    status = isActive ? 'in-progress' : 'completed';
  } else {
    const now = new Date();
    const end = endDate ? new Date(endDate) : null;
    if (end && now > end) status = 'completed';
  }

  const label = status === 'in-progress' ? 'In progress' : 'Completed';
  return (
    <span className={['status-badge', status, className].filter(Boolean).join(' ')}>{label}</span>
  );
};
